<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-spin-clockwise">
</ngx-spinner>

<nb-layout>
	<nb-layout-header fixed>
		<div class="toolbar" role="banner">
			<img alt="Logo" [src]="logo" class="logo" />
			<div class="spacer"></div>
		</div>
	</nb-layout-header>

	<nb-layout-column>
		<div class="page" *ngIf="!loading">

			<div class="page-header">
				<h1 class="page-title">{{ config.PageTitle || 'Seguimiento' }}</h1>
			</div>

			<div class="section" *ngIf="notFound">
				<p class="not-found-text">
					<nb-icon icon="alert-circle-outline"></nb-icon>
					No se ha encontrado ningún expediente con el número de seguimiento proporcionado.
				</p>
				<button nbButton status="basic" size="small" (click)="goBack()">
					<nb-icon icon="arrow-back-outline"></nb-icon>
					Volver a la búsqueda
				</button>
			</div>

			<div class="page-card" *ngIf="!notFound && fields.length">
				<div class="detail-layout">

					<div class="left-column">
						<div class="fields-section">
							<h2 class="section-title">{{ config.FormTitle }}</h2>

							<div class="field-list">
								<div class="field-item" *ngFor="let field of fields">
									<span class="field-label">{{ field.label }}</span>
									<span class="field-value">{{ field.value }}</span>
								</div>
							</div>
						</div>

						<div class="files-section" *ngIf="itemFiles.length">
							<h2 class="section-title">Archivos</h2>
							<div class="file-chips">
								<span class="file-chip" *ngFor="let file of itemFiles">
									<nb-icon icon="file-outline"></nb-icon>
									{{ file.name }}
								</span>
							</div>
						</div>

						<div class="upload-wrapper" *ngIf="uploadFormSchema">
							<h2 class="section-title">Documentos</h2>

							<div class="upload-section" *ngIf="!uploadSuccess">
								<formio id="upload-formio"
									[form]="uploadFormSchema"
									[submission]="uploadSubmission"
									[refresh]="refreshUploadForm"
									[renderOptions]="renderOptions"
									(submit)="onUploadSubmit($event)">
								</formio>
							</div>

							<div class="upload-success" *ngIf="uploadSuccess">
								<nb-icon icon="checkmark-circle-2-outline"></nb-icon>
								<span>Archivos subidos correctamente</span>
							</div>
						</div>
					</div>

					<div class="right-column">
						<div class="workflow-section" *ngIf="workflowSteps.length > 0">
							<h2 class="section-title">Información del seguimiento</h2>

							<div class="workflow-timeline">
								<div class="timeline-step {{ step.status }}" *ngFor="let step of workflowSteps; let last = last">
									<div class="step-left">
										<div class="step-dot">
											<nb-icon *ngIf="step.status === 'done'" icon="checkmark-outline"></nb-icon>
											<nb-icon *ngIf="step.status === 'active'" icon="radio-button-on-outline"></nb-icon>
											<nb-icon *ngIf="step.status === 'finalized'" icon="checkmark-circle-2-outline"></nb-icon>
										</div>
										<div class="step-line" *ngIf="!last"></div>
									</div>
									<div class="step-content">
										<span class="step-name">{{ step.name }}</span>
										<span class="step-date" *ngIf="step.date">{{ step.date }}</span>
										<span class="step-badge {{ step.status }}">
											<span *ngIf="step.status === 'done'">Completado</span>
											<span *ngIf="step.status === 'active'">En curso</span>
											<span *ngIf="step.status === 'pending'">Pendiente</span>
											<span *ngIf="step.status === 'finalized'">Finalizado</span>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>
	</nb-layout-column>
</nb-layout>
